<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Automated Debug'|translate }}
                </v-card-title>
                <v-card-text v-if="loading">
                    <v-progress-linear :indeterminate="true"></v-progress-linear>

                </v-card-text>
                <v-card-text v-if="!loading">
                    <v-card-title class="accent white--text subheading">
                        {{ 'Mapping Integrity Issues'|translate }}
                        <v-spacer></v-spacer>
                        <v-btn class="accent" @click="exportIntegrityIssues">
                            <v-icon small class="mr-2">fa-download</v-icon>
                            {{'Download'|translate}}
                        </v-btn>
                        <div style="height: 24px; margin-right: 12px;">
                            <v-switch color="success"
                                      v-model="integrityErrorOnly"
                                      :label="'Error Only'|translate"
                            ></v-switch>
                        </div>
                    </v-card-title>
                    <v-data-table
                        :headers="integrityHeaders"
                        :items="refinedIntegrityIssues"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.name }}</td>
                            <td>{{ props.item.type }}</td>
                            <td>
                                <v-chip :color="getColor(props.item.status)" style="color:#404040 !important;">
                                    {{ props.item.status }}
                                </v-chip>
                            </td>
                            <td>
                                <ul v-if="props.item.missingCriticalSensors">
                                    <li v-for="i in props.item.missingCriticalSensors">{{ i }}</li>
                                </ul>
                            </td> <td>
                                <ul v-if="props.item.missingImportantSensors">
                                    <li v-for="i in props.item.missingImportantSensors">{{ i }}</li>
                                </ul>
                            </td>
                            <td>
                                <ul v-if="props.item.missingOptionalSensors">
                                    <li v-for="i in props.item.missingOptionalSensors">{{ i }}</li>
                                </ul>
                            </td>


                        </template>

                    </v-data-table>
                </v-card-text>
                <v-card-text v-if="!loading">
                    <v-card-title class="accent white--text subheading">
                        {{ 'Custom View Configuration Issues'|translate }}
                    </v-card-title>
                    <v-data-table
                        :headers="headers"
                        :items="mcv"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.name }}</td>
                            <td>
                                <ul v-if="props.item.issues">
                                    <li v-for="i in props.item.issues">{{ i }}</li>
                                </ul>
                            </td>
                            <td>
                                <v-icon class="mr-2"
                                        small
                                        @click="viewView(props.item)"
                                >
                                    fa-eye
                                </v-icon>
                                <v-icon class="mr-2"
                                        small
                                        @click="editView(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                            </td>

                        </template>

                    </v-data-table>
                </v-card-text>
                <v-card-text v-if="!loading&&dataIssues">
                    <v-card-title class="accent white--text subheading">
                        {{ 'Data Issues'|translate }}
                        <v-spacer></v-spacer>
                        <v-btn class="accent" @click="exportUnitIssues">
                            <v-icon small class="mr-2">fa-download</v-icon>
                            {{'Download'|translate}}
                        </v-btn>
                        <div style="height: 24px; margin-right: 12px;">
                            <v-switch color="success"
                                      v-model="unitErrorOnly"
                                      :label="'Error Only'|translate"
                            ></v-switch>
                        </div>
                    </v-card-title>
                    <v-data-table
                        :headers="dataIssuesHeaders"
                        :items="refinedDataIssues"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.Equipment_name }}</td>
                            <td>{{ props.item.sensor_name }}</td>
                            <td>{{ props.item.Issue }}</td>
                            <td>{{ props.item.flatline }}</td>
                            <td>{{ props.item.Unit }}</td>
                            <td>{{ props.item.Counts }}</td>
                            <td>{{ props.item.Out_of_range_Counts }}</td>
                            <td>{{ props.item.Min }}</td>
                            <td>{{ props.item.Max }}</td>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-text v-if="!loading&&ruleIssues">
                    <v-card-title class="accent white--text subheading">
                        {{ 'Rule Issues'|translate }}
                        <v-spacer></v-spacer>
                        <v-btn class="accent" @click="exportRuleIssues">
                            <v-icon small class="mr-2">fa-download</v-icon>
                            {{'Download'|translate}}
                        </v-btn>
                        <div style="height: 24px; margin-right: 12px;">
                            <v-switch color="success"
                                      v-model="ruleErrorOnly"
                                      :label="'Error Only'|translate"
                            ></v-switch>
                        </div>
                    </v-card-title>
                    <v-data-table
                        :headers="ruleIssuesHeaders"
                        :items="refinedRuleIssues"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.title }}</td>
                            <td>{{ props.item.rule_check }}</td>
                            <td>{{ props.item.rule }}</td>
                            <td>{{ props.item.equipment_type }}</td>
                            <td>{{ props.item.equipment_name }}</td>
                            <td>{{ props.item.relevant_variables }}</td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {mapGetters} from 'vuex'
import {getResult} from '@/helper'
import {exportCSV} from '../tocsv'
import integrity from '../config/pointMapping/integrity'
import _ from "lodash";

export default {
    name: 'AutomatedDebug',
    components: {},
    data() {
        return {
            loading: true,
            errorColors: {
                'critical': 'red',
                'warning': 'yellow',
                'error': 'orange',
                'OK': 'green'
            },
            headers: [
                {text: this.$options.filters.translate('Name'), value: 'name'},
                {text: this.$options.filters.translate('Issues'), value: 'notes', sortable: false},
                {text: this.$options.filters.translate('Actions'), value: 'notes', sortable: false},
            ],
            integrityHeaders: [
                {text: this.$options.filters.translate('Equipment Name'), value: 'name'},
                {text: this.$options.filters.translate('Equipment Type'), value: 'type'},
                {text: this.$options.filters.translate('Status'), value: 'status'},
                {text: this.$options.filters.translate('Missing Critical Sensors'), value: 'missingCriticalSensors', sortable: false},
                {text: this.$options.filters.translate('Missing Important Sensors'), value: 'missingImportantSensors', sortable: false},
                {text: this.$options.filters.translate('Missing Optional Sensors'), value: 'missingOptionalSensors', sortable: false},
            ],
            mcv: [],
            dataIssues: [],
            ruleIssues: [],
            integrityIssues: [],
            unitErrorOnly: true,
            integrityErrorOnly: true,
            ruleErrorOnly: true,
            dataIssuesHeaders: [
                {text: this.$options.filters.translate('Equipment Name'), value: 'Equipment_name'},
                {text: this.$options.filters.translate('Sensor Name'), value: 'sensor_name'},
                {text: this.$options.filters.translate('Issue'), value: 'Issue'},
                {text: this.$options.filters.translate('Flatline'), value: 'flatline'},
                {text: this.$options.filters.translate('Unit'), value: 'Unit'},
                {text: this.$options.filters.translate('Counts'), value: 'Counts'},
                {text: this.$options.filters.translate('Out of range Counts'), value: 'Out_of_range_Counts'},
                {text: this.$options.filters.translate('Min'), value: 'Min'},
                {text: this.$options.filters.translate('Max'), value: 'Max'},
            ],
            ruleIssuesHeaders: [
                {text: this.$options.filters.translate('Title'), value: 'title'},
                {text: this.$options.filters.translate('Issue'), value: 'rule_check'},
                {text: this.$options.filters.translate('Rule'), value: 'rule'},
                {text: this.$options.filters.translate('Equipment Type'), value: 'equipment_type'},
                {text: this.$options.filters.translate('Equipment Name'), value: 'equipment_name'},
                {text: this.$options.filters.translate('Relevant Variables'), value: 'relevant_variables'},

            ],
        }
    },
    computed: {
        ...mapGetters([
            'publishedCustomViews'
        ]),
        refinedDataIssues() {
            if (this.dataIssues && this.unitErrorOnly) {
                return this.dataIssues.filter(x => x.error_level === "Error")
            } else {
                return this.dataIssues
            }
        },
        refinedRuleIssues() {
            if (this.ruleIssues && this.ruleErrorOnly) {
                return this.ruleIssues.filter(x => x.error_level === "Error")
            } else {
                return this.ruleIssues
            }
        },
        refinedIntegrityIssues() {
            if (this.integrityIssues && this.integrityErrorOnly) {
                return this.integrityIssues.filter(x => x.status !== "OK")
            } else {
                return this.integrityIssues
            }
        }
    },
    mounted() {
        let me = this
        getResult({
            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            result_name: 'unit check'
        }).then(function (res) {
            if (res && res.result && res.result[0]) {
                me.dataIssues = res.result[0].content.filter(x => x.Issue)
            }
        })
        getResult({
            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            result_name: 'rule_checking'
        }).then(function (res) {
            if (res && res.result && res.result[0]) {
                me.ruleIssues = res.result[0].content.filter(x => x.rule_check)
            }
        })
        let combinations = this.$store.state.pointsListStore.pointsList.points_list.map(sensor => {
            return {
                sensor_name: sensor.sensor_name,
                equipment_name: sensor.equipment_name,
                equipment_type: this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].equipment_type,
                equipment_tags: this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].equipment_tags ? this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].equipment_tags : [],
                floor: this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].floor,
            }
        })
        let issues = {}
        for (let customView of this.publishedCustomViews) {
            if (customView.plotList) {
                for (let item of customView.plotList) {
                    if (item.type === "data3-chart") {
                        for (let query of item.config["data-payload"]) {
                            let matchingItems = combinations.filter(x => {
                                for (let key of Object.keys(query.filters)) {
                                    if (x[key] !== query.filters[key]) {
                                        return false
                                    }
                                }
                                return true
                            })
                            if (matchingItems.length === 0) {
                                if (!issues[customView.id]) {
                                    issues[customView.id] = {
                                        name: customView.title,
                                        id: customView.id,
                                        issues: []
                                    }
                                }
                                let issue = "No sensors matching filters :"
                                let first = true
                                for (let key of Object.keys(query.filters)) {
                                    if (!first) {
                                        issue = issue + ","
                                    }
                                    issue = issue + " " + key + " = " + query.filters[key]
                                    first = false
                                }
                                if (issues[customView.id].issues.indexOf(issue) < 0) {
                                    issues[customView.id].issues.push(issue)
                                }
                            }
                        }
                    }
                }
            }
        }
        issues = Object.values(issues)
        this.mcv = issues
        let integrityIssues=[]
        for (let index in this.$store.state.pointsListStore.pointsList.equipment_details) {
            let equip=this.$store.state.pointsListStore.pointsList.equipment_details[index]
            if (integrity[equip.equipment_type]){
                let equipSensors=this.$store.state.pointsListStore.pointsList.sensors[index]
                let interityIssue={
                    name:equip.equipment_name,
                    id:equip.equipment_id,
                    type:equip.equipment_type,
                    status:"OK",
                    missingCriticalSensors:[],
                    missingImportantSensors:[],
                    missingOptionalSensors:[]
                }
                if (integrity[equip.equipment_type].importantSensors){
                    interityIssue.missingImportantSensors=integrity[equip.equipment_type].importantSensors.filter(x=>!equipSensors.includes(x))
                }
                if (integrity[equip.equipment_type].criticalSensors){
                    interityIssue.missingCriticalSensors=integrity[equip.equipment_type].criticalSensors.filter(x=>!equipSensors.includes(x))
                }
                if (integrity[equip.equipment_type].optionalSensors){
                    interityIssue.missingOptionalSensors=integrity[equip.equipment_type].optionalSensors.filter(x=>!equipSensors.includes(x))
                }
                if (interityIssue.missingCriticalSensors.length>0){
                    interityIssue.status="Critical"
                } else if (interityIssue.missingImportantSensors.length>0){
                    interityIssue.status="Error"
                }else if (interityIssue.missingOptionalSensors.length>0){
                    interityIssue.status="Warning"
                }
                integrityIssues.push(interityIssue)
            }
        }
        this.integrityIssues=integrityIssues
        this.loading = false
    },
    methods: {
        getColor(x) {
            return _.get(this.errorColors, x.toLowerCase(), 'green')
        },
        exportRuleIssues() {
            exportCSV(this.ruleIssues)
        },
        exportUnitIssues() {
            exportCSV(this.dataIssues)
        },
        exportIntegrityIssues() {
            exportCSV(this.integrityIssues)
        },
        editView(view) {
            let output = {
                path: '/custom-view-builder',
                query: {
                    view: view.id,
                }
            }
            window.open(this.$router.resolve(output).href)
        }, viewView(view) {
            let output = {
                path: '/user-automated/' + view.id,
            }
            window.open(this.$router.resolve(output).href)
        },
    }
}
</script>

<style scoped>

</style>
